export const SITE_NAME = "日漫精选推荐";
export const SITE_SLOGAN = "告别漫荒，快速找到对胃口的日漫神作";
export const SITE_DESC =
  "日漫精选推荐为你推荐日漫恋爱、日漫热血、日漫悬疑、日漫治愈、日漫机战等热门题材，日漫神作精选榜单持续更新，帮你快速找到对胃口的作品，解决漫荒难题。";
export const SITE_KEYWORDS =
  "日漫,日漫恋爱,日漫热血,日漫悬疑,日漫治愈,日漫机战,日漫神作,动漫推荐";
export const BASE_URL = "https://mangarev4.github.io";

export const SITE_LOGO =
  "https://readdy.ai/api/search-image?query=minimal%20round%20emblem%20logo%20of%20a%20film%20clapperboard%20with%20sunrise%20rays%2C%20vermillion%20red%20and%20gold%20on%20cream%20background%2C%20flat%20clean%20vector%20style&width=200&height=200&seq=logo-riman&orientation=squarish";